module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIGhlaWdodD0iNDgwIiB3aWR0aD0iNjQwIiB2aWV3Qm94PSIwIDAgNjQwIDQ4MCI+CiAgPGcgZmlsbC1ydWxlPSJldmVub2RkIiBzdHJva2Utd2lkdGg9IjFwdCI+CiAgICA8cGF0aCBmaWxsPSIjZmZmIiBkPSJNMCAwaDYzOS45OTV2NDgwLjAwNEgweiIvPgogICAgPHBhdGggZmlsbD0iIzAwOUE0OSIgZD0iTTAgMGgyMTMuMzM0djQ4MC4wMDRIMHoiLz4KICAgIDxwYXRoIGZpbGw9IiNGRjc5MDAiIGQ9Ik00MjYuNjY4IDBoMjEzLjMzNHY0ODAuMDA0SDQyNi42Njh6Ii8+CiAgPC9nPgo8L3N2Zz4K"


//////////////////
// WEBPACK FOOTER
// ./~/flag-icon-css/flags/4x3/ie.svg
// module id = ./node_modules/flag-icon-css/flags/4x3/ie.svg
// module chunks = 0